import {
  CREATE_PROJECT_SUCCESS,
  FETCH_PROJECT_SUCCESS,
  DELETE_PROJECT_SUCCESS,
  CLONE_PROJECT_SUCCESS,
  UPDATE_PROJECT_ERROR,
  CLEAR_PROJECT
} from '.'

const projectReducer = (state, action) => {
  switch (action.type) {
    case CREATE_PROJECT_SUCCESS:
      return {
        ...state,
        editor: {
          ...state.editor,
          isUserActiveInEditor: false
        },
        generationForm: {},
        currentProject: { projectId: action.payload.project_id },
        history: []
      }

    case FETCH_PROJECT_SUCCESS:
      return {
        ...state,
        editor: {
          ...state.editor,
          isUserActiveInEditor: false
        },
        history: [],
        generationForm: {
          speakingRate: action.payload.project.speaking_rate,
          text: action.payload.project.text
        },

        currentProject: {
          imageUrl: action.payload.project.image_url,
          videoUrl: action.payload.project.video_url,
          projectId: action.payload.project.project_id,
          imageHash: action.payload.project.image_hash,
          projectDataHash: action.payload.project.project_data_hash,
          imageExtension: action.payload.project.image_extension
        }
      }

    case DELETE_PROJECT_SUCCESS:
      return {
        ...state,
        editor: {
          ...state.editor,
          isUserActiveInEditor: false
        },
        currentProject: {},
        generationForm: {},
        history: state.history.filter((item) => item.project_id !== action.payload.project_id)
      }

    case CLONE_PROJECT_SUCCESS:
      return {
        ...state,
        editor: {
          ...state.editor,
          isUserActiveInEditor: false
        },
        generationForm: {},
        clonedProjectId: action.payload.project_id,
        history: [
          {
            ...action.payload
          },
          ...state.history
        ]
      }

    case CLEAR_PROJECT:
      return {
        ...state,
        editor: {
          ...state.editor,
          isUserActiveInEditor: false
        },
        history: [],
        currentProject: {},
        generationForm: {}
      }

    case UPDATE_PROJECT_ERROR:
      return {
        ...state,
        currentProject: {
          ...state.currentProject,
          details: [...action.payload.details]
        }
      }

    default:
      console.error('Unknown action', action.type, action.payload)
      return state
  }
}

export { projectReducer }
